export const common = {
  // Auth
  login: "Login",
  register: "Register", 
  logout: "Logout",
  email: "Email",
  password: "Password",
  confirmPassword: "Confirm Password",
  fullName: "Full Name",
  phone: "Phone Number",
  rememberMe: "Remember me",
  forgotPassword: "Forgot password?",
  noAccount: "Don't have an account?",
  haveAccount: "Already have an account?",
  registerNow: "Register now",
  loginNow: "Login now",
  agreeTerms: "I agree to the",
  termsOfUse: "Terms of Use",
  privacyPolicy: "Privacy Policy",
  orLoginWith: "Or login with",
  
  // Common
  theme: "Theme",
  language: "Language",
  light: "Light",
  dark: "Dark",
  vietnamese: "Vietnamese",
  english: "English",
  
  // Navigation
  home: "Home",
  signals: "Trading",
  education: "Education",
  plans: "Plans",
  partners: "Partners",
  contact: "Introduction",
  
  // Homepage
  heroTitle: "Professional Trading",
  heroTitleHighlight: "Platform",
  heroSubtitle: "Join the leading trader community with accurate signals, detailed trading plans, and valuable trading knowledge.",
  getStarted: "Get Started",
  viewSignals: "View Trading",
  featuresTitle: "Key Features",
  featuresSubtitle: "Comprehensive tools and services for traders",
  
  // Features
  tradingSignals: "Trading Signals",
  tradingSignalsDesc: "Receive accurate trading signals from expert team with high success rate",
  tradingPlans: "Trading Plans",
  tradingPlansDesc: "Create and manage detailed trading plans, download or share to group",
  tradingEducation: "Trading Education",
  tradingEducationDesc: "Learn from in‑depth articles on technical analysis and market psychology",
  telegramIntegration: "Telegram Integration",
  telegramIntegrationDesc: "Connect with Telegram group to receive notifications and share documents",
  discordCommunity: "Discord Community",
  discordCommunityDesc: "Join discussions and receive trading signals, periodic reports via Discord",
  resultsReport: "Results Report",
  resultsReportDesc: "Track monthly signal results summary with detailed statistics",
  
  // Stats
  statsTitle: "Recent Month Results",
  statsSubtitle: "Trading signal performance statistics",
  successRate: "Success Rate",
  signalsSent: "Signals Sent",
  avgProfit: "Total Profit",
  activeMembers: "Active Members",
  
  // Partners
  partnersTitle: "Partner Network",
  partnersSubtitle: "Partnering with leading exchanges",
  
  // CTA
  ctaTitle: "Ready to start trading?",
  ctaSubtitle: "Join the professional trader community today",
  registerFree: "Register Free",
  userGuide: "User Guide",
  
  // Footer
  footerDescription: "Professional trading platform with accurate signals and strong trader community.",
  services: "Services",
  support: "Support",
  contactInfo: "Contact",
  
  // Messages
  passwordMismatch: "Password confirmation does not match!",
  loginToAccount: "Access your account",
  createNewAccount: "Join the professional trader community - Get free signals today",
  
  // Placeholders
  enterEmail: "Example: email@domain.com",
  enterPassword: "Enter password (minimum 8 characters)",
  enterFullName: "Example: John Doe",
  enterPhone: "Example: 0912345678",
  reenterPassword: "Re-enter password to confirm",
  
  // Trading History Page (formerly Signals Page)
  signalsPageTitle: "Trading History",
  signalsPageSubtitle: "Track and analyze your completed trades",
  todaySignals: "Today's Trades",
  monthlyProfit: "Monthly Profit",
  monthlySignals: "This Month's Trades",
  timeframe: "Timeframe",
  status: "Status",
  all: "All",
  active: "Active",
  profit: "Profit",
  loss: "Loss",
  refresh: "Refresh",
  
  // Education Page
  educationPageTitle: "Trading Education",
  educationPageSubtitle: "Enhance your trading skills with in‑depth articles",
  technical: "Technical Analysis",
  educationStrategy: "Strategy",   // renamed to avoid duplicate
  risk: "Risk Management",
  psychology: "Psychology",
  news: "News",
  readMore: "Read More",
  newsletterTitle: "Subscribe to Newsletter",
  newsletterSubtitle: "Receive latest articles and weekly market analysis",
  subscribe: "Subscribe",
  
  // Plans Page
  plansPageTitle: "Create Trading Plan",
  plansPageSubtitle: "Plan your trades in detail",
  planInfo: "Plan Information",
  planName: "Plan Name",
  symbol: "Symbol",
  entryPrice: "Entry Price",
  stopLoss: "Stop Loss",
  takeProfit: "Take Profit",
  riskReward: "Risk/Reward Ratio",
  strategy: "Strategy",   // kept here (unique now)
  notes: "Notes",
  riskLevel: "Risk Level",
  createPlan: "Create Plan",
  downloadPlan: "Download",
  shareToTelegram: "Share to Telegram",
  
  // Partners Page
  partnersPageTitle: "Partner Network",
  partnersPageSubtitle: "Partnering with world's leading trading platforms",
  benefits: "Benefits of registering through 123Trading",
  reducedFees: "Reduced Trading Fees",
  reducedFeesDesc: "Get the best trading fee discounts when registering through our link",
  signupBonus: "Signup Bonus",
  signupBonusDesc: "Receive special bonuses and gifts when creating a new account",
  support247: "24/7 Support",
  support247Desc: "Get direct support from 123Trading team when encountering issues",
  exchanges: "Exchanges",
  tools: "Tools",
  data: "Data",
  // registerNow key removed from this section to avoid duplicate
  
  // Contact Page
  contactPageTitle: "Contact Us",
  contactPageSubtitle: "We're always ready to support you",
  sendMessage: "Send Message",
  name: "Name",
  subject: "Subject",
  message: "Message",
  contactMethod: "Preferred Contact Method",
  sendMessageBtn: "Send Message",
  contactInfoLabel: "Contact Information",   // renamed to avoid duplicate
  supportHours: "Support Hours",
  quickFaq: "Quick FAQ"
};

export default common;